import { render } from "./BomValidationResultsDetails.vue?vue&type=template&id=c37024fa&scoped=true"
import script from "./BomValidationResultsDetails.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsDetails.vue?vue&type=script&lang=js"

import "./BomValidationResultsDetails.vue?vue&type=style&index=0&id=c37024fa&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37024fa"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
